/* eslint-disable @typescript-eslint/naming-convention */
interface IUsage {
    description: string;
}

interface IOffer {
    description: string;
    monthlyAmount: number;
    usages: IUsage[];
}

export enum EDomain {
    FIBER = "FIBER",
    MOBILE = "MOBILE",
}

export enum EServiceGroup {
    SA_BB = "SA_BB",
}

interface IService {
    id: string;
    name?: string;
}

export interface ISimCard {
    pin1Code: string;
    puk1Code: string;
}

export enum EESimStatus {
    AVAILABLE = "AVAILABLE",
    ENABLED = "ENABLED",
    DOWNLOADED = "DOWNLOADED",
    INSTALLED = "INSTALLED",
    DELETED = "DELETED",
}

export interface IESim {
    activationQrCode: string;
    activationQrCodeFormat: string;
    esimStatus: EESimStatus;
    esimPassCode: string;
}

interface IAddon {
    description: string;
    price: number;
    quantity: number;
}

export enum EStatus {
    ACTIVE = "ACTIVE",
    INITIAL = "INITIAL",
}

export interface ISubscription {
    status: EStatus;
    activatedAt: string;
    offer: IOffer;
    service: IService;
    terminationRequestScheduledAt?: string;
    addons?: IAddon[];
}

export interface IMobileSubscription extends ISubscription {
    eSim?: IESim;
    simCard?: ISimCard;
}

export interface IBroadbandSubscription extends ISubscription {
    combiDiscountAmount?: number;
    uan?: string;
}

export interface IAccountDetailsPage {
    id: string;
    mobileSubscriptions: IMobileSubscription[];
    broadbandSubscription?: IBroadbandSubscription;
}
